import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaHome, FaArrowLeft } from 'react-icons/fa';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-safir-dark via-safir-secondary to-safir-primary">
      <Navbar />
      
      {/* Background decoration */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 right-10 w-72 h-72 bg-safir-primary opacity-20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 left-10 w-96 h-96 bg-safir-secondary opacity-20 rounded-full blur-3xl"></div>
      </div>

      {/* Main Content */}
      <div className="flex-grow flex items-center justify-center px-4 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-2xl"
        >
          {/* 404 Number */}
          <motion.div
            initial={{ scale: 0.5, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="mb-8"
          >
            <h1 className="text-9xl md:text-[150px] font-bold text-white opacity-20 mb-0">
              404
            </h1>
          </motion.div>

          {/* Error Message */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="mb-8"
          >
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Page Not Found
            </h2>
            <p className="text-xl text-gray-100 mb-2">
              Sorry, the page you're looking for doesn't exist.
            </p>
            <p className="text-gray-200">
              This route is not available on the public website.
            </p>
          </motion.div>

          {/* Action Buttons */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="flex flex-col sm:flex-row gap-4 justify-center"
          >
            <Link to="/">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="bg-safir-primary hover:bg-safir-secondary text-white font-bold py-3 px-8 rounded-lg transition-all duration-300 flex items-center justify-center gap-2 w-full sm:w-auto"
              >
                <FaHome size={18} />
                Go to Home
              </motion.button>
            </Link>
            <button
              onClick={() => window.history.back()}
              className="bg-white hover:bg-gray-100 text-safir-dark font-bold py-3 px-8 rounded-lg transition-all duration-300 flex items-center justify-center gap-2 w-full sm:w-auto"
            >
              <FaArrowLeft size={18} />
              Go Back
            </button>
          </motion.div>

          {/* Helpful Links */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="mt-12 pt-8 border-t border-white border-opacity-20"
          >
            <p className="text-gray-200 mb-6">Here are some helpful links:</p>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
              {[
                { href: "/", label: "Home" },
                { href: "/courses", label: "Courses" },
                { href: "/events", label: "Events" },
                { href: "/about", label: "About Us" },
                { href: "/donate", label: "Donate" },
                { href: "/contact", label: "Contact" },
              ].map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className="text-safir-primary hover:text-white transition-colors font-semibold"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </motion.div>
        </motion.div>
      </div>

      <Footer />
    </div>
  );
};

export default NotFoundPage;
